import React, { memo, useCallback } from "react";
import colors from "app/colors";

import { IconButton } from "@chakra-ui/react";
import { useAuth } from "modules/providers/auth-provider";
import { EyeIcon, EyeSlashIcon } from "modules/icons";
import SyncoTooltip from "modules/_shared/synco-tooltip";
import useToggleUserHideEmail from "modules/hooks/use-toggle-user-hide-email";

const ToggleHideEmailButton = () => {
  const { me } = useAuth();
  const toggle = useToggleUserHideEmail();

  const onClick = useCallback(
    (e: React.MouseEvent<HTMLElement>) => {
      e.stopPropagation();
      e.preventDefault();
      toggle();
    },
    [toggle],
  );

  if (!me) {
    return null;
  }

  return (
    <SyncoTooltip
      placement="top"
      // offset tooltip from right edge of browser frame so that it is not touching the right edge
      offset={[-100, 0]}
      label={
        me.isHideEmail
          ? "Allow users to see my email"
          : "Don’t allow users to see my email"
      }
    >
      <IconButton
        aria-label="toggle hide email"
        onClick={onClick}
        variant="ghost"
        size="xs"
        icon={
          me.isHideEmail ? (
            <EyeSlashIcon boxSize={5} fill={colors.gray30} />
          ) : (
            <EyeIcon boxSize={5} fill={colors.blue} />
          )
        }
      />
    </SyncoTooltip>
  );
};

export default memo(ToggleHideEmailButton);
